import { BrowserRouter } from 'react-router';
import { Toaster } from '@/shared/components/ui/sonner';
import { QueryProvider } from '@/app/providers/QueryProvider';
import { AuthProvider } from '@/app/providers/AuthProvider';
import { I18nProvider } from '@/app/providers/I18nProvider';
import { ErrorBoundary } from '@/shared/components/ErrorBoundary';
import { AppRoutes } from '@/app/routes';

export function App() {
  return (
    <ErrorBoundary>
      <I18nProvider>
        <QueryProvider>
          <AuthProvider>
            <BrowserRouter>
              <AppRoutes />
              <Toaster position="top-right" richColors closeButton />
            </BrowserRouter>
          </AuthProvider>
        </QueryProvider>
      </I18nProvider>
    </ErrorBoundary>
  );
}
